export default __webpack_public_path__ + "static/media/Red0004.46be5aa9.png";